import { render, staticRenderFns } from "./FloatingButtons.vue?vue&type=template&id=f45c98ce"
import script from "./FloatingButtons.vue?vue&type=script&lang=js"
export * from "./FloatingButtons.vue?vue&type=script&lang=js"
import style0 from "./FloatingButtons.vue?vue&type=style&index=0&id=f45c98ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports